import authService from '../services/authService';

/**
 * Where the micro simulation pages live for each role.
 *
 * The same pages serve trainers (who run sessions), clients (who unlock topics for
 * their organisation and read results) and super-admins (who manage the catalogue and
 * preview drafts), each under their own area so the right sidebar and back links show.
 */
const BASE = { trainer: '/trainer', client: '/client', 'super-admin': '/admin' };

export const microSimPaths = (role) => {
  const base = BASE[role] || '/trainer';
  return {
    library: role === 'super-admin' ? '/admin/micro-sims' : `${base}/micro-sims`,
    topic: (slug) => `${base}/micro-sims/${slug}`,
    preview: (slug, runId) => `${base}/micro-sims/${slug}/preview/${runId}`,
    launch: (launchId) => `${base}/micro-sim-launches/${launchId}`,
    session: (sessionId) => {
      if (role === 'client') return `/client/sessions/${sessionId}`;
      if (role === 'super-admin') return `/admin/sessions/${sessionId}`;
      return `/trainer/session/${sessionId}/control`;
    },
    home: role === 'client' ? '/client/dashboard' : role === 'super-admin' ? '/admin/dashboard' : '/trainer/sessions',
  };
};

/** Paths for the signed-in user. */
export const useMicroSimPaths = () => {
  const role = authService.getCurrentUser()?.role;
  return { role, ...microSimPaths(role) };
};
